import { ThemeEvents } from '@theme/events';

// Instances Splide déjà équipées : empêche tout écouteur en double.
const warmedSliders = new WeakSet();

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
    this.warmUpLazySlides();
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  updateMediaGallery = (event) => {
    const newMediaGallery = event.detail.data.html.querySelector('product-media-gallery slider-component');
    const currentMediaGallery = this.querySelector('slider-component');

    if (!newMediaGallery || !currentMediaGallery) return;

    if (currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.replaceWith(newMediaGallery);
      this.warmUpLazySlides();
    }
  };

  // Les diapositives 2+ sont en loading="lazy". Chrome (121+) les précharge déjà dans un
  // carrousel, mais WebKit ne le fait qu'à partir de son correctif de 2025 (bug 264864) :
  // sur les iPhone plus anciens, l'image n'arriverait qu'une fois visible.
  // On demande donc la diapositive suivante juste avant d'en avoir besoin.
  warmUpLazySlides() {
    const splide = this.querySelector('slider-component')?.slider;
    if (!splide || typeof splide.on !== 'function' || warmedSliders.has(splide)) return;
    warmedSliders.add(splide);

    const slides = Array.from(this.querySelectorAll('.product-media-gallery-main-slider .splide__list > .splide__slide'));
    if (slides.length < 2) return;

    const promote = (from, to) => {
      slides.slice(Math.max(0, from), to + 1).forEach((slide) => {
        slide.querySelectorAll('img[loading="lazy"]').forEach((image) => {
          image.loading = 'eager';
        });
      });
    };

    // Diapositive 2 : seulement après l'affichage de l'image LCP, pendant un temps libre.
    const warmSecondSlide = () => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => promote(1, 1), { timeout: 2000 });
      } else {
        setTimeout(() => promote(1, 1), 200);
      }
    };
    const firstImage = slides[0].querySelector('img');
    if (!firstImage || firstImage.complete) {
      warmSecondSlide();
    } else {
      firstImage.addEventListener('load', warmSecondSlide, { once: true });
      firstImage.addEventListener('error', warmSecondSlide, { once: true });
    }

    // Chaque déplacement (swipe, flèche, clic sur une miniature) : la cible et ses voisines.
    splide.on('move', (newIndex) => promote(newIndex - 1, newIndex + 1));
  }
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}
